<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <p>二级指标：</p>
            <el-row>
              <el-button type="info" :class="{active:search_data.type==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type" v-show="item.id!=1">{{item.name}}</el-button>
            </el-row>
          </div>
        </div>
      <l-auth-button class="ivu-mr" type="primary" auth="rental_examine_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
      <l-auth-button type="primary" auth="specs_import_btn" @click="import_visible=true" :loading="import_loading"> 导入 </l-auth-button>
      <div class="l-simple-search-container" style="float: right;">
        <el-input placeholder="请输入查找内容" v-model="search_data.name" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>
      <el-table-column prop="state" label="状态" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="row.state == 1 ? 'success' : 'danger'" size="small" disable-transitions>{{ STATE_NAMES[row.state] }}</el-tag>
          <!-- <el-tag type="success" size="small"  disable-transitions>{{ STATE_NAMES[row.state] }}</el-tag> -->
        </template>
      </el-table-column>

      <!-- <el-table-column prop="danger_lavel" label="隐患等级" width="100">
        <template slot-scope="{ row }">
          <el-tag type="danger" size="small" v-if="row.danger_lavel == 1" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          <el-tag type="danger" size="small" v-if="row.danger_lavel == 2" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          <el-tag type="warning" size="small" v-if="row.danger_lavel == 3" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          <el-tag type="success" size="small" v-if="row.danger_lavel == 4" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          <el-tag type="success" size="small" v-if="row.danger_lavel == 5" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          <a size="small" v-else disable-transitions></a>
        </template>
      </el-table-column> -->

      <el-table-column prop="grade" label="等级" width="120">
        <template slot-scope="{ row }">
          <el-tag type="info" disable-transitions> {{ STATE[row.grade] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="project_name" label="归属项目" min-width="150"> </el-table-column>
      <el-table-column prop="content_name" label="归属内容" min-width="180"></el-table-column>
      <el-table-column prop="name" label="检查内容" min-width="250">
        <template slot-scope="{ row }">
          <a style="color: cornflowerblue;" @click="showInfo(row.id)" v-if="row.grade == 3">{{row.name}}</a>
           <a v-else>{{row.name}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="fraction" label="对应分值" min-width="100">
        <template slot-scope="{ row }">
          {{row.fraction}}(分)
        </template>
      </el-table-column>
      <el-table-column prop="method" label="检查方法" width="110"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="rental_examine_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="rental_examine_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加资源" width="1000px">
      <l-rental-edit @on-success="onAddSucess" :visible.sync="add_visible"></l-rental-edit>
    </l-dialog>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="添加隐患描述,整改建议" width="1400px">
      <l-retal-info @on-success="onAddSucess" :visible.sync="info_visible" :id="info_id"></l-retal-info>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑资源" width="1000px">
      <l-rental-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-rental-edit>
    </l-dialog>

    <!--导入-->
    <l-dialog :visible.sync="import_visible" title="导入" width="800px">
      <l-place-import @on-success="onImportSuccess" :visible.sync="import_visible" />
    </l-dialog>
  </el-card>
</template>

<script>
import { STATE, STATE_NAMES, LEVEL } from './rental';
import Edit from "./Edit.vue";
import Info from "./Info.vue";
import Import from "./Import.vue";
import Vue from "vue";
export default {
  components: {
    [Edit.name]: Edit,
    [Info.name]: Info,
    [Import.name]: Import,

  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      info_visible: false,
      edit_visible: false, //是否显示编辑
      import_visible:false,
      edit_id: 0,
      info_id: 0,
      STATE: STATE,
      STATE_NAMES: STATE_NAMES,
      LEVEL: LEVEL,
      //默认场所数据  改场所为  住宅
      place_type:7,
      //搜索
      search_visible: false,
      search_data: {
        name: "",
      },
      rel_search_data: {},
      show_more_search: false,
    };
  },

  mounted() {
    this.getList();
  },
computed:{
    place_type_list(){
      return this.$store.state.list.place_type_list
    }
  },
  methods: {
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("checkSpecs_rentalGetList", {
        page: this.page,
        page_size: this.page_size,
        place_type:this.place_type,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //显示详情和添加隐患描述和解决
    showInfo(id) {

      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
//通过类型筛选
    placetype(id) {
      this.search_data.place_type = id;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.show_change_pwd = true;
      });
    },

    //修改密码成功回调
    onChangePwdSuccess() {
      this.show_change_pwd = false;
    },

    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`checkSpecs_del`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },
    //显示导入
    onImportSuccess() {
      this.import_visible = false;
      this.getList();
    },
  },
};
</script>
